import { SELECIONAR_ENDERECO_DESTINATARIO } from '../types'

export default function selecionarEnderecoRemetente (endereco) {
  return {
    type: SELECIONAR_ENDERECO_DESTINATARIO,
    payload: endereco
  }
}
